import { render, staticRenderFns } from "./SupportRegister.vue?vue&type=template&id=87185d2e&scoped=true&lang=pug"
import script from "./SupportRegister.vue?vue&type=script&lang=ts"
export * from "./SupportRegister.vue?vue&type=script&lang=ts"
import style0 from "./SupportRegister.vue?vue&type=style&index=0&id=87185d2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87185d2e",
  null
  
)

export default component.exports